var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Plus = function Plus(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 445 445' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { fill: 'currentColor', d: 'M427.4 199.7H245.3V17.6h-45.6v182.1H17.6v45.6h182.1v182.1h45.6V245.3h182.1z', fillRule: 'evenodd', clipRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Plus;
//# sourceMappingURL=Plus.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Plus.js